module.exports = __webpack_public_path__ + "img/plate_stopped.548639c8.svg";